import { render, staticRenderFns } from "./headDialogLink.vue?vue&type=template&id=1439b499&scoped=true"
import script from "./headDialogLink.vue?vue&type=script&lang=js"
export * from "./headDialogLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1439b499",
  null
  
)

export default component.exports